export default __webpack_public_path__ + "static/media/enterprise-network-solution.30f44b3b.jpg";